import { render, staticRenderFns } from "./SupplierPage.vue?vue&type=template&id=7fc8b6ba&scoped=true&"
import script from "./SupplierPage.vue?vue&type=script&lang=js&"
export * from "./SupplierPage.vue?vue&type=script&lang=js&"
import style0 from "./SupplierPage.vue?vue&type=style&index=0&id=7fc8b6ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc8b6ba",
  null
  
)

export default component.exports